// src/components/GlobalError.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { ErrorOutline, Refresh } from '@mui/icons-material';

const GlobalError = ({ errorMessage, onRetry }) => {
    const navigate = useNavigate();
    if (!errorMessage) return null;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '50vh',
                textAlign: 'center',
                gap: 2,
                px: 2,
            }}
        >
            <ErrorOutline sx={{ fontSize: 48, color: 'error.main' }} />
            <Typography variant="body1" sx={{ color: 'text.primary' }}>
                {errorMessage}
            </Typography>
            {onRetry && (
                <Button
                    variant="outlined"
                    startIcon={<Refresh />}
                    onClick={onRetry}
                >
                    再試行
                </Button>
            )}
            <Button
                variant="contained"
                onClick={() => {
                    navigate('/', { replace: true });
                    window.location.reload();
                }}
            >
                トップへ戻る
            </Button>
        </Box>
    );
};

export default GlobalError;